module.exports = __webpack_public_path__ + "assets/img/1.a40f5089.png";